// extracted by mini-css-extract-plugin
module.exports = {"alert":"Alert_alert__N48kC","info":"Alert_info__1fgjH","success":"Alert_success__2GhMp","error":"Alert_error__3H0oD","close":"Alert_close__x6MhK"};